import React from "react";
import "./Fold.scss";
import homeCoconutLeft from "./images/home-coconut-left.webp";
import homeCoconutRight from "./images/home-coconut-right.webp";
import homeBubblesDown from "./images/bubbles-down-home.svg";
import homeBubblesUp from "./images/bubbles-up.svg";
import andImage from "./images/and.svg";
import cheersImage from "./images/cheers.svg";
function Fold({ t }) {
  return (
    <div className="flex flex-align-center flex-justify-center relative fold shadow-main-navigation">
      <img
        className="home-coconut-left"
        width={"100%"}
        height={"auto"}
        src={homeCoconutLeft}
      ></img>
      <img
        className="home-bubbles-up"
        width={"100%"}
        height={"auto"}
        src={homeBubblesUp}
      ></img>
      <div className="content-fold relative col-7 col-12-xs col-12-sm col-12-md text-center p-2 p-top-8-md p-top-8-sm p-top-4-xs text-primary text-lg text-md">
        <div className="m-bottom-1 m-top-2">{t.dearGuests}</div>
        <div className="m-bottom-5">{t.we}</div>
        <h1 className="names-fontsize text-italic text-primary"><span className="p-right-4 p-right-2-xsm">{t.brideName}</span></h1>
        <div className="flex flex-align-end flex-justify-center">
          <img
            className="fold-and-image"
            width={"100%"}
            height={"auto"}
            src={andImage}
            alt="and"
          /><h1 className="names-fontsize text-italic text-primary">{t.groomName}</h1></div>
        <div className="col-9 col-12-xs col-12-sm col-12-md col-12-lg m-inline-auto m-top-4 p-inline-4-sm m-top-5" >
          {t.invitationText}
        </div>
        <h2 className="m-top-4 m-bottom-1 font-body custom-date-font-size text-primary text-italic"><span className="font-body font-weight-700">14</span> <span className="font-heading">{t.june}</span>, <span className="font-body font-weight-bold font-weight-700">2026</span></h2>
      </div>
      <img
        className="home-coconut-right"
        width={"100%"}
        height={"auto"}
        src={homeCoconutRight}
      >
      </img>
      <img
        className="home-bubbles-down"
        width={"100%"}
        height={"auto"}
        src={homeBubblesDown}
      ></img>
    </div>
  );
}

export default Fold;
